/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Fixed/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputCurrency from 'DesignSystem/TysiaInput/TysiaInputCurrency/index'



/** @type {import('Simple/types.js').View} */
export default function Fixed({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPayments/Content/Content/MinimumDownpaymentAmount/AmountOrPercentage/Fixed",
  onChange
  
}) {
let settingsDataMinimumDownpaymentAmountValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'data.minimum_downpayment.amount',
})
let settingsDataMinimumDownpaymentAmountChangeData = fromData.useDataChange({ viewPath,
context: 'settings',
path: 'data.minimum_downpayment.amount',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="settings.data.minimum_downpayment.amount"
 value={settingsDataMinimumDownpaymentAmountValueData}
 onChange={settingsDataMinimumDownpaymentAmountChangeData}
 marginTop={0}
 maxWidth={150}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputCurrency
{...childProps}
  viewPath={`${viewPath}/TysiaInputCurrency`}
 placeholder="$0.00"
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
{children}
</React.Fragment>)
}